export const PHONE_DISPLAY = "049 5564729";
export const PHONE_TEL = "tel:0495564729";
export const MOBILE_DISPLAY = "348 005 0606";
export const MOBILE_TEL = "tel:3480050606";
export const ADDRESS = "Via Lovati 1/A, 35011 Reschigliano di Campodarsego (PD)";
export const INSTAGRAM_URL = "https://www.instagram.com/centroesteticobiovital";
export const INSTAGRAM_HANDLE = "@centroesteticobiovital";
export const FACEBOOK_URL = "https://www.facebook.com/p/Centro-Estetico-Benessere-Biovital-100059731135153/";
export const MAP_EMBED =
  "https://maps.google.com/maps?q=Via%20Lovati%201%2FA%20Campodarsego%20Padova&t=&z=15&ie=UTF8&iwloc=&output=embed";
export const TEAM_PHOTOS = ["/images/titolare-poster.jpg", "/images/salone-5.jpg"];

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "servizi", label: "Servizi" },
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "novita", label: "Novità e Promozioni" },
  { id: "recensioni", label: "Recensioni" },
  { id: "contatti", label: "Contatti" },
];

export const HOURS = [
  { day: "Lunedì", hours: "Chiuso", closed: true },
  { day: "Martedì", hours: "09:00 – 19:00" },
  { day: "Mercoledì", hours: "09:00 – 19:00" },
  { day: "Giovedì", hours: "09:00 – 19:00" },
  { day: "Venerdì", hours: "09:00 – 19:00" },
  { day: "Sabato", hours: "09:00 – 15:00" },
  { day: "Domenica", hours: "Chiuso", closed: true },
];

export const SERVICES = [
  {
    id: "viso",
    icon: "Sparkles",
    title: "Trattamenti Viso & Skincare",
    desc: "Pulizia profonda del viso, trattamenti antietà pre e post menopausa e protocolli personalizzati mirati alle diverse esigenze della pelle, con l'utilizzo esclusivo di cosmesi biologica certificata.",
    duration: "50–75 min",
    tags: ["Cosmesi bio", "Antietà", "Su misura"],
    image: "/images/viso.jpg",
  },
  {
    id: "massaggi",
    icon: "Waves",
    title: "Massaggi Corpo e Viso",
    desc: "Massaggi corpo: ayurvedici (Pitta, Kapha, Vata), Soul Caress, Terrakua, stone massage e riflessologia plantare. Massaggi viso: Kobido e Buccal Lift Face Massage.",
    duration: "50–60 min",
    tags: ["Ayurvedico", "Kobido", "Stone massage"],
    image: "/images/massaggio-viso-corpo.jpg",
  },
  {
    id: "anticellulite",
    icon: "Droplets",
    title: "Trattamenti Anticellulite",
    desc: "Protocolli specifici anticellulite abbinati a massaggi riducenti e drenanti, con attivi naturali che stimolano il microcircolo e ridefiniscono la silhouette seduta dopo seduta.",
    duration: "60 min",
    tags: ["Riducente", "Microcircolo", "Percorso"],
    image: "/images/anticellulite.jpg",
  },
  {
    id: "laser",
    icon: "Zap",
    title: "Epilazione Laser Progressiva",
    desc: "Epilazione laser progressiva permanente con tecnologia di ultima generazione: sedute rapide, sicure e confortevoli per una pelle liscia e libera nel tempo.",
    duration: "15–60 min",
    tags: ["Permanente", "Indolore", "Tutti i fototipi"],
    image: "/images/salone-2.jpg",
  },
  {
    id: "depilazione",
    icon: "Feather",
    title: "Depilazione & Filo Orientale",
    desc: "Depilazione tradizionale con cere delicate e ceretta brasiliana, e la raffinata tecnica del filo orientale per sopracciglia e viso: precisione millimetrica e rispetto della pelle più sensibile.",
    duration: "15–45 min",
    tags: ["Filo orientale", "Cera delicata", "Sopracciglia"],
    image: "/images/salone-3.jpg",
  },
  {
    id: "mani-piedi",
    icon: "Hand",
    title: "Manicure & Pedicure",
    desc: "Possibilità di applicazione di smalto tradizionale o semipermanente a lunga tenuta.",
    duration: "40–70 min",
    tags: ["Semipermanente", "Spa mani", "Pedicure curativa"],
    image: "/images/manicure.jpg",
  },
];

export const GALLERY = [
  { src: "/images/salone-11.jpg", alt: "Corridoio e accoglienza del centro", span: "md:col-span-2 md:row-span-2" },
  { src: "/images/salone-6.jpg", alt: "Lampada al collagene", span: "md:row-span-2" },
];


export const FALLBACK_REVIEWS = [
  { id: "f1", name: "Giulia M.", location: "Campodarsego", rating: 5, service: "Trattamento viso bio", text: "Finalmente un centro dove la pelle viene trattata con prodotti davvero naturali. Dopo il protocollo antietà personalizzato la mia pelle è luminosa e compatta come non lo era da anni." },
  { id: "f2", name: "Francesca B.", location: "Padova", rating: 5, service: "Epilazione laser", text: "Percorso di epilazione laser progressiva: professionalità, zero dolore e risultati visibili già dalla terza seduta. Le ragazze ti seguono passo passo." },
  { id: "f3", name: "Martina R.", location: "Camposampiero", rating: 5, service: "Massaggio drenante", text: "Il massaggio drenante abbinato al trattamento anticellulite ha fatto la differenza: gambe leggere e pelle più tonica. Un'ora di pace assoluta." },
];
